// Lockable UI widget implementation
import $ from "jquery";
import _ from "underscore";

// Implements a lockable input text.
//
// should be some input field with data-lockable with a page-unique identifier.
//
// Value of form input with matching data-lockable-value is set to 0 or 1 based on lock state
export class Lockable {
  constructor(element, options = {}) {
    this._setState = this._setState.bind(this);
    this._updateStyles = this._updateStyles.bind(this);

    this.name = null;
    this.element = null;
    this.indicator_element = null;
    this.value_element = null;
    this.locked = false;

    this.options = {
      // Classes for locked/unlocked state applied to indicator_element
      //
      // Note that these are NOT the unlock/lock icons (below)
      locked_class: "locked",
      unlocked_class: "unlocked",

      // FontAwesome icon classes
      //
      // This applies to any elements matching icon_selector (below)
      locked_icon: "fa-lock",
      unlocked_icon: "fa-unlock",

      // Selector for icon inside the indicator_element (including indicator_element)
      // FontAwesome icon classes, above, will be applied to any matching element
      icon_selector: "i.fa",
    };
    _.extend(this.options, options);

    this.element = $(element);
    this.name = this.element.data("lockable");

    this.indicator_element = $(`[data-lockable-status='${this.name}']`);
    this.value_element = $(`[data-lockable-value='${this.name}']`);

    this.locked = this.value_element.val() === "true";

    this._updateStyles();
    this._attachEvents();
  }

  // Attach events to keep elements in sync
  //
  // Which events are listened to depends on the type of input (i.e. is it rich text, etc.)
  _attachEvents() {
    const event_names = this.element.is("[data-rich-text]")
      ? "slzr:richtext:change.lockable"
      : "change.lockable keypress.lockable slzr:location:remove.lockable";

    this.element.on(event_names, (event) => {
      return this._setState(true);
    });

    return this.indicator_element.on("click", (event) => {
      this._setState(!this.locked);
      return event.preventDefault();
    });
  }

  _setState(locked) {
    this.locked = locked;
    this._updateStyles();
    return this.value_element.val(locked ? "true" : "false");
  }

  // Update active styles for the current lock state
  _updateStyles() {
    this.indicator_element.toggleClass(this.options.locked_class, this.locked);
    this.indicator_element.toggleClass(this.options.unlocked_class, !this.locked);

    let icon_elements = this.indicator_element.find(this.options.icon_selector);
    if (this.indicator_element.is(this.options.icon_selector)) {
      icon_elements = icon_elements.add(this.indicator_element);
    }

    icon_elements.toggleClass(this.options.locked_icon, this.locked);
    return icon_elements.toggleClass(this.options.unlocked_icon, !this.locked);
  }
}
